module.exports = __webpack_public_path__ + "img/dora.7ad56953.png";